import { Component } from "react";
import { CommonService } from "../js_modules/CommonService";
import { SellToWebAdminDropdownComponent } from "../common/selltowebdropdown/SellToWebAdminDropdownComponent";
import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";
import { AdminRouteComponent } from "../admin/AdminRouteComponent";

export class TenantQueryComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTenant: null,
            showSpinner: false
        };

        this.onTenantClick = this.onTenantClick.bind(this);
        this.onGetClick = this.onGetClick.bind(this);
    }

    componentDidUpdate() {
        try {
            if (this.props.tenants && !this.state.selectedTenant) {
                let selectedTenant = null;
                let urlPath = window.location.pathname.split("/");
                let tenantGuid = urlPath[3];
                if (tenantGuid !== "") {
                    selectedTenant = this.props.tenants.find(tenant => tenant.guid === tenantGuid);
                }
                let cookieTenant = CommonService.getCookie(AdminRouteComponent.TenantCookie);
                if (!selectedTenant && cookieTenant !== "") {
                    selectedTenant = this.props.tenants.find(tenant => tenant.guid === cookieTenant);
                }
                if (!selectedTenant) {
                    selectedTenant = this.props.tenants[0];
                }

                this.setState({
                    selectedTenant: selectedTenant
                }, this.onTenantClick(null, selectedTenant));
            }
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailQueryComponent", "componentDidUpdate");
        }
    }

    onTenantClick(event, selectedTenant) {
        try {
            CommonService.setCookie(AdminRouteComponent.TenantCookie, selectedTenant ? selectedTenant.guid : "", 30);
            
            this.setState({
                selectedTenant: selectedTenant,
            }, this.onGetClick);

        }
        catch (error) {
            console.logError(error, "TenantQueryComponent", "onTenantClick");
        }
    }

    onGetClick(event) {
        try {
            this.props.onGetClick(this.state.selectedTenant);
        }
        catch (error) {
            console.logError(error, "TenantQueryComponent", "onGetClick");
        }
    }

    render() {
        return <div className="card">
            <div className="card-block">
                <div className="row">
                    {
                        this.props.isGlobalAdmin
                            ? <SellToWebAdminDropdownComponent label="Tenant" data={this.props.tenants} itemKey="name" onItemClick={this.onTenantClick} value={this.state.selectedTenant ? this.state.selectedTenant.name : "Select Tenant"} controlSpan="admin-tenant-control" />
                            : <div className="admin-control col-auto">
                                <div className="input-group align-items-center">
                                    <label className="admin-label col-form-label">
                                        Tenant:
                                    </label>
                                    {this.state.selectedTenant?.name}
                                </div>
                            </div>
                    }
                    
                    <div className="col-auto admin-query-btn">
                        <button className="btn btn-primary" disabled={this.state.showSpinner} onClick={(event) => this.onGetClick(event)}>
                            Get <i className="far fa-redo-alt admin-icon" />
                        </button>
                        {/* <button className="btn btn-primary admin-icon" disabled>
                            Save <i className="fas fa-save admin-icon" />
                        </button> */}
                    </div>
                    <div style={{ "height": "33px", "width": "auto" }}>
                        <SellToWebSpinnerComponent className="admin-icon" showSpinner={this.state.showSpinner || this.props.isLoadingData} />
                    </div>
                </div>
            </div>
        </div>;
    }
}